import { APIS } from '../../../../../lib/constants/apis';

// import Schemas
import MittelabrufSchema from '../../../../../lib/paths/mittelabruf_FULL_Paths.json';
const MA_P = MittelabrufSchema.attributes;

type Dependencies = {
	files: any[];
	relations: any[];
};
function MittelabrufDependencies(_application: any) {
	let dependencies: Dependencies = {
		files: [],
		relations: [],
	};
	dependencies.relations.push({ field: MA_P.Mittelabruf_Nachweispositions.path, api: APIS.Nachweisposition });

	// if (get(application, `${P.Mittelabruf_Verwendungsnachweiss.path}.id`)) {
	// 	dependencies.relations.push({
	// 		field: P.Mittelabruf_Verwendungsnachweiss.schema.attributes.Verwendungsnachweis_Nachweispositions.path,
	// 		api: APIS.Nachweisposition,
	// 	});
	// 	dependencies.relations.push({
	// 		field: P.Mittelabruf_Verwendungsnachweiss.schema.attributes.Verwendungsnachweis_Stundennachweiss.path,
	// 		api: APIS.StundenNachwies,
	// 	});
	// 	dependencies.relations.push({
	// 		field: P.Mittelabruf_Verwendungsnachweiss.schema.attributes.Verwendungsnachweis_Abschreibungs.path,
	// 		api: APIS.Abschreibung,
	// 	});
	// 	dependencies.relations.push({
	// 		field: P.Mittelabruf_Verwendungsnachweiss.path,
	// 		api: APIS.Verwendungsnachweis,
	// 	});
	// }

	return dependencies;
}
export { MittelabrufDependencies };
